import {tagEquals, TagModel} from './BaseTagModel';

/**
 * Used to denote which tags are provided by the backend
 */
export const SystemTagModel = TagModel.extend({
    idAttribute: 'uuid',
    blacklist: ['included', 'order'],
    defaults: () => ({
        included: true,
        userGenerated: false,
        weight: 1,
    }),
    equals(tag) {
        return tagEquals(this, tag);
    },
    /**
     * Use to determine if the tag should have an order
     *
     * @returns {boolean}
     */
    getIsOrderable() {
        return false;
    },
});

SystemTagModel.of = (...args) => new SystemTagModel(...args);

export default SystemTagModel;